import { Injectable } from '@angular/core';
import {
  getDownloadURL,
  getStorage,
  ref,
  uploadBytes,
  uploadString,
} from '@angular/fire/storage';
@Injectable({
  providedIn: 'root',
})
export class FilesService {
  constructor() {}
  public async uploadFile(path: string, file: File, metadata?: any) {
    const uploadTask = await uploadBytes(
      ref(getStorage(), path),
      file,
      { customMetadata:metadata }
    );
    return this.getetFileUrlByRefAsync(uploadTask.ref);
  }
  public async getetFileUrlByRefAsync(ref: any) {
    return await getDownloadURL(ref);
  }
  public async getFileUrlAsync(file: string) {
    return await getDownloadURL(ref(getStorage(), file));
  }
  public async uploadBase64(
    base64: string,
    folderName: string,
    path?: string,
    metaData?: any
  ) {
    const uploadTask = await uploadString(
      ref(getStorage(), folderName + path),
      base64,
      'base64',
      { customMetadata: metaData }
    );
    return this.getetFileUrlByRefAsync(uploadTask.ref);
  }
}
